import { render, staticRenderFns } from "./ManageNetworksModal.vue?vue&type=template&id=5b037f06&scoped=true"
import script from "./ManageNetworksModal.vue?vue&type=script&lang=ts"
export * from "./ManageNetworksModal.vue?vue&type=script&lang=ts"
import style0 from "./ManageNetworksModal.vue?vue&type=style&index=0&id=5b037f06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b037f06",
  null
  
)

export default component.exports